import { render, staticRenderFns } from "./Periodos.vue?vue&type=template&id=81aa84d2&scoped=true&"
import script from "./Periodos.vue?vue&type=script&lang=js&"
export * from "./Periodos.vue?vue&type=script&lang=js&"
import style0 from "./Periodos.vue?vue&type=style&index=0&id=81aa84d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa84d2",
  null
  
)

export default component.exports